<template>
  <div class="px-4">
    <router-view />
    <NotificationContainer />
  </div>
</template>

<script setup>
import NotificationContainer from "@/components/notifications/NotificationContainer.vue";
</script>

<style></style>
